import { state, settings } from './state';
import { getActiveConversationSession } from './app-hooks';
import { I18N } from './i18n';
import { updateContextBadge, updateTokenInfo, updateWebSearchToggle } from './ui';

/**
 * Действующий system-промпт «Разговора» — то, что реально уедет на сервер, а не
 * то, что записано в одном из полей. С этапа A-4 инструкция Человека дополняет
 * промпт категории, а не вытесняет его (ADR-006 §2.5): сборка на сервере —
 * `buildSystemLayers`, и расхождение этих двух мест означало бы, что экран
 * показывает не действующее значение, а одно из слагаемых.
 *
 * Оценка контекста и бейдж считаются по этой же строке, поэтому склейка нужна и
 * ради арифметики, а не только ради показа.
 */
export function buildEffectiveSystemPrompt(categoryName?: string | null): string {
  const catName = categoryName || state.currentUser?.category || '';
  const categoryPart = (state.categories?.[catName]?.system_prompt || '').trim();
  const userPart = (state.currentUser?.system_prompt || '').trim();
  const effective = [categoryPart, userPart].filter((part) => part.length > 0).join('\n\n');
  if (effective) return effective;
  const defaultPrompt = I18N?.[state.lang]?.system_prompt_placeholder || '';
  return defaultPrompt;
}

/** Category switch: replace effective prompt and drop stale system messages from history. */
export function applyCategorySystemPrompt(categoryName?: string | null): void {
  settings.system_prompt = buildEffectiveSystemPrompt(categoryName);
  const session = getActiveConversationSession();
  if (session) {
    session.history = session.history.filter((m) => m.role !== 'system');
  }
  updateTokenInfo();
  updateContextBadge();
  updateWebSearchToggle();
}
